export default function (arr, key, duplicates = false) {
  const result = [];
  JSON.stringify(arr, (objkey, value) => {
    if (objkey === key) result.push(value);
    return value;
  });
  return duplicates ? result.filter(Boolean) : [...new Set(result.filter(Boolean))];
}
